import React, { useEffect } from 'react'
import styled from 'styled-components/macro'

import Logo from '../../components/Logo/Logo'
import { Header, HeaderWrapper } from '../Shared/Components'
import Footer from '../../components/Footer/Footer'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  /* ie11, adding height pxs also */
  @media only screen and (-ms-high-contrast: active) and (-ms-high-contrast: none) and (min-height: 1100px) {
    height: 100vh;
  }
`

const Hero = styled.div`
  padding: 80px 16px;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;

  @media only screen and (min-width: 768px) {
    min-height: 516px;
  }
`

const HeroTitle = styled.h1`
  font-family: 'Pluto Sans', sans-serif;
  font-weight: normal;
  font-size: 32px;
  line-height: 40px;
  color: ${(props) => props.theme.colors.brand.primary};
  text-align: center;
  margin-bottom: 24px;

  @media only screen and (min-width: 768px) {
    font-size: 48px;
    line-height: 56px;
    margin-bottom: 40px;
    max-width: 820px;
  }
`

const HeroSubtitle = styled.h3`
  font-family: 'Pluto Sans', sans-serif;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.grey.grey7};
  text-align: center;

  @media only screen and (min-width: 768px) {
    font-size: 24px;
    line-height: 32px;
    max-width: 820px;
  }
`

const Confirmation = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  })

  return (
    <Wrapper>
      <Header>
        <HeaderWrapper>
          <Logo version='full' />
        </HeaderWrapper>
      </Header>
      <Hero grow>
        <HeroTitle>
          Confirmation. <br />
          You will be receiving your $10 voucher by email as well as reminders
          to do your screeners & enter the main reward draw.
        </HeroTitle>
        <HeroSubtitle>
          Look out for these reminders so you can enter before the closing date
          of xx/xx/20
        </HeroSubtitle>
      </Hero>
      <Footer>Footer</Footer>
    </Wrapper>
  )
}

export default Confirmation
